<div class="page-holder">

    <div class="title-holder">
        <div class="center-content">
            <div class="top-element-holder">
                <div class="text-holder left top">
                    <h2 class="title uppercase">Dołącz do grona naszych partnerów</h2>
                    <button class="custom-button" (click)="goToContactForm()"> Dołącz już teraz</button>
                </div>
                <div class="image-holder top">
                    <img src="/assets/images/ba_a_partner.png" alt="Zostań naszym partnerem">
                </div>
            </div>
        </div>
    </div>
    <div class="statistics-holder">
        <div class="center-content tree-cols">
            <div class="statistic-item">
                <div class="icon"><img src="/assets/images/ba_a_partner_icon_users.svg"></div>
                <div class="number">50 000+</div>
                <div class="label">Użytkowników</div>
                <div class="text">Dostęp do bazy 50 000+ użytkowników szukających ofert, </div>
            </div>
            <div class="statistic-item">
                <div class="icon"><img src="/assets/images/ba_a_partner_icon_partners.svg"></div>
                <div class="number">200+</div>
                <div class="label">Partnerów</div>
                <div class="text">Współpraca z ponad 200 partnerami, </div>
            </div>
            <div class="statistic-item">
                <div class="icon"><img src="/assets/images/ba_a_partner_icon_offers.svg"></div>
                <div class="number">250+</div>
                <div class="label">Ofert</div>
                <div class="text">Dostęp do ponad 250 ofert, </div>
            </div>
        </div>
    </div>

    <div class="info-text-holder">
        <div class="center-content two-cols">
            <div>
                <h2>Co zyskujesz?</h2>
                <p>
                    Dostęp do bazy 50 000+ użytkowników szukających ofert, zwiększenie widoczności Twojej marki,
                    generowanie
                    nowych leads bez ponoszenia kosztów marketingu. Nasze narzędzia analityczne pomagają śledzić
                    efektywność
                    kampanii i optymalizować oferty w czasie rzeczywistym.</p>
            </div>
            <div>
                <h2>Bez kosztów bez ryzyka</h2>
                <p>Dołączając do naszego programu partnerskiego, nie ponosisz żadnych kosztów ani ryzyka. Możesz skupić
                    się
                    na rozwijaniu swojej działalności, a my zajmiemy się resztą.</p>
            </div>
        </div>
    </div>

    @if (false) {
    <div class="info-text-holder">
        <div class="center-content two-cols">

            <a name="contact-form"></a>
            <div class="column-content contact-form-column">
                <h2>Wyślij zapytanie i zostań naszym partnerem</h2>

                @if (emailSent) {
                <div class="success-message-container">
                    <div class="success-icon">
                        <mat-icon class="success-checkmark">check_circle</mat-icon>
                    </div>
                    <h3>Wiadomość została wysłana!</h3>
                    <p>Dziękujemy za kontakt. Wkrótce odpowiemy na Twoją wiadomość.</p>
                    <button class="custom-button" mat-raised-button color="primary" (click)="sendNewEmail()">
                        Wyślij nową wiadomość
                    </button>
                </div>
                }

                <!-- Contact Form (shown when no email sent yet) -->
                @if (!emailSent) {
                <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                    <!-- Message Title Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Firma</mat-label>
                        <input matInput formControlName="title" />
                        @if (contactForm.get('title')?.hasError('required')) {
                        <mat-error>
                            Nazwa firmy
                        </mat-error>
                        }
                    </mat-form-field>

                    <!-- Title Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Imię i nazwisko</mat-label>
                        <input matInput formControlName="name" />
                        @if (contactForm.get('name')?.hasError('required')) {
                        <mat-error>
                            Imię i nazwisko jest wymagane
                        </mat-error>
                        }
                    </mat-form-field>
                    <!-- Email Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Twój adres email</mat-label>
                        <input matInput type="email" formControlName="email" />
                        @if (contactForm.get('email')?.hasError('email')) {
                        <mat-error>
                            Proszę podać prawidłowy adres email
                        </mat-error>
                        }
                    </mat-form-field>

                    <!-- Phone Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Telefon</mat-label>
                        <input matInput type="tel" formControlName="phone" />
                    </mat-form-field>

                    <!-- Message Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Twoja wiadomość</mat-label>
                        <textarea matInput formControlName="message" rows="4"></textarea>
                        @if (contactForm.get('message')?.hasError('required')) {
                        <mat-error>
                            Wiadomość jest wymagana
                        </mat-error>
                        }
                    </mat-form-field>
                    <!-- CAPTCHA Field -->
                    <div class="captcha-container">
                        <p>{{ captchaQuestion }}</p>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Zabezpieczenie przed spamem. Twoja odpowiedź</mat-label>
                            <input matInput formControlName="captcha" />
                            @if (contactForm.get('captcha')?.hasError('required')) {
                            <mat-error>
                                Odpowiedź jest wymagana
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <!-- Submit Button -->
                    <button class="custom-button" mat-raised-button color="primary" type="submit"
                        [disabled]="contactForm.invalid">
                        Wyślij wiadomość
                    </button>
                </form>
                }
            </div>
        </div>
    </div>
    }
</div>